import { formatPoundsAmount } from '@/src/utils/money';

export const strings = {
  title: (energyType: string) => `Top up your ${energyType}`,
  enterAmountLabel: 'Enter amount:',
  currentBalance: 'Current balance',
  newBalance: 'New balance',
  backButton: 'Back',
  continueButton: 'Continue',
  nonIntegerError: 'You can only top up pounds, not pence',
  minTopupError: (minTopupInPence: number) =>
    `Enter more than ${formatPoundsAsInteger(minTopupInPence - 100)}`,
  maxTopupError: (maxTopupInPence: number) =>
    `Enter ${formatPoundsAsInteger(maxTopupInPence)} or less`,
  maxBalanceError: (maxBalanceInPence: number) =>
    `Your balance can’t be more than ${formatPoundsAsInteger(
      maxBalanceInPence,
    )}`,
};

function formatPoundsAsInteger(amountInPence: number) {
  return formatPoundsAmount(amountInPence / 100).slice(0, -3);
}
